<template>
  <div id="dashboard-page">
    <b-card>
        <h3>{{$route.name}}</h3>
        <b-breadcrumb>
          <b-breadcrumb-item><router-link to="/vehicle-dashboard">Vehicle Dashboard</router-link></b-breadcrumb-item>
          <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
        <hr>
        <b-row>
          <b-col md="9">
              <b-row class="mt-3 mb-3">
                  <b-col md="3">
                      <b-form-input :placeholder="'Search by plate'" v-model="tableFilter.plate" customQueryParamName="search" />
                  </b-col>
                  <b-col md="3">
                      <b-form-input :placeholder="'Search by merk'" v-model="tableFilter.merk" customQueryParamName="search" />
                  </b-col>
                  <b-col md="6">
                    <b-button variant="primary" class="btn-back float-left btn-custom" @click="doFilter"><font-awesome-icon icon="search"/></b-button>
                  </b-col>
              </b-row>
          </b-col>
        </b-row>
        <paginated-table ref="dataTable" :can-show="true" :can-edit="false" :can-delete="false" :can-approve="false" :can-reject="false" :data-url="apiUrl" :data-key="dataKey" :data-columns="columns" :data-params="['merk', 'plate']">
        </paginated-table>
    </b-card>
    </div>
</template>

<script>
  import PaginatedTable from '@/components/PaginatedTable'
  export default {
    components: {
      PaginatedTable
    },
    data () {
      return {
        dataKey: 'vehicles',
        apiUrl: window.AppConfig.apiUrl + 'vehicle?status=0',
        columns: [
          {
            key: 'plate',
            sortable: true
          },
          {
            key: 'merk',
            sortable: true
          },
          {
            key: 'model',
            sortable: true
          },
          {
            key: 'requestedBy',
            sortable: true
          },
          {
            key: 'statusVehicle',
            label: 'Status',
            sortable: false
          },
          {
            key: 'actions',
            label: ''
          }
        ],
        tableFilter: {
          merk: this.$route.query.merk,
          plate: this.$route.query.plate
        }
      }
    },
    methods: {
      doFilter () {
        this.tableFilter.plate = this.tableFilter.plate
        this.tableFilter.merk = this.tableFilter.merk
        this.$refs.dataTable.doFilter(this.tableFilter)
      }
    }
  }
</script>
